import { TransactionsObj } from '../application/commons/types/transactionTypes';
import { useStubbornService, UseStubbornServiceOptions } from '../lib/StubbornService/react';

const SERVICE_ID = 'getTransactionById';

export const useGetSingleTransaction = (params: { transactionId: string }, options: UseStubbornServiceOptions) => {
  return useStubbornService<{ transaction: TransactionsObj }>(SERVICE_ID, params, options);
};
